module.exports = __webpack_public_path__ + "img/15180327000160.cee9e99b.png";